import { isEmbedded } from 'lib/useragent';

const getQuerystringParam = (name, from = window?.location?.search) => {
  const match = new RegExp('[?&]' + name + '=([^&]*)').exec(from);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

const isEmbeddedForce = getQuerystringParam('forceEmbed') || false;

const subDomain = process.env.REACT_APP_VHOST || 'www';
const isEnvProd = process.env.REACT_APP_BUILD_ENV === 'prod';
const env = process.env.REACT_APP_BUILD_ENV; // dev | prelive | prod
const environment = process.env.REACT_APP_BUILD_ENV || process.env.NODE_ENV;

let domain = '';

if (!isEnvProd && environment !== 'production') {
  domain = `.${env ?? 'prelive'}`;
}

const staticHost = `https://s${domain}.winamax.fr`;

const webHosts = {
  en: `https://${subDomain}${domain}.winamax.fr/en`,
  de: `https://${subDomain}${domain}.winamax.de`,
  it: `https://${subDomain}${domain}.winamax.it`,
  es: `https://${subDomain}${domain}.winamax.es`,
  fr: `https://${subDomain}${domain}.winamax.fr`,
  pt: `https://${subDomain}${domain}.winamax.pt`,
};

const apiHostByLang = lang => `https://wapi${domain}.winamax.${lang}`;

const apiHosts = {
  en: apiHostByLang('fr'),
  de: apiHostByLang('fr'),
  it: apiHostByLang('fr'),
  es: apiHostByLang('es'),
  fr: apiHostByLang('fr'),
  pt: apiHostByLang('pt'),
};

const Target = {
  __ENV__: environment,
  __API_HOSTS__: apiHosts,
  __EMBEDDED__: process.env.REACT_APP_LIB_ENV ? false : isEmbeddedForce || isEmbedded || window.config.IS_BETTING_EMBEDDED || window.config.IS_POKER_EMBEDDED,
  __WEBHOSTS__: webHosts,
  __STATIC_HOST__: staticHost,
};

console.debug(`%c runtime | target / embed %O`, 'background: #616161; color: #fff;', {
  target: 'mobile',
  embed: Target.__EMBEDDED__,
  webHosts: Target.__WEBHOSTS__,
  staticHost,
});

export default Target;
